module.exports = __webpack_public_path__ + "placa_smart_10x_s_entr_s_juros.png?3b26522c49b1adfd1044f54c8afab142";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_smart_10x_s_entr_s_juros.png
// module id = 130
// module chunks = 0